import { I18n } from 'i18n-js'

// Create a new I18n instance
const i18n = new I18n()

// Initialize translations object
i18n.translations = {}

// Add extend method
i18n.extend = (target, source) => {
  return Object.assign(target, source)
}

// Make it globally available before loading locales
window.I18n = i18n

// Load translations
require('./locales/en.js')
require('./locales/ru.js')
require('./locales/lv.js')

// Set locale when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body
  if (body) {
    const locale = body.dataset.locale || 'lv'
    const defaultLocale = body.dataset.defaultLocale || 'lv'
    
    // Set the locale
    i18n.locale = locale
    i18n.defaultLocale = defaultLocale
    
    // Update HTML lang attribute
    document.documentElement.lang = locale
  }
})

// Make it available globally if in a browser context
if (typeof window !== 'undefined') {
  window.I18n = i18n
}

export default i18n
